import { useEffect } from "react";
import { useDispatch } from "react-redux";

import ErrorComponent from "web/Layout/Common/ErrorComponent";
import { SkeletonHeaderMenu } from "web/Layout/Common/SkeletonComponents";

import { useGetMenuQuery } from "web/features/api/graphQLApiSlice";
import { setRestrictions } from "web/features/customerMenu/customerMenuSlice";

import MainMenuContainerWithCategoryIds from "./mainMenuContainerWithCategoryIds";

const MainMenuContainer = () => {
  const { data, isLoading, isError } = useGetMenuQuery();
  const dispatch = useDispatch();

  const clientMenu = data?.customerMenu ?? "{}";

  useEffect(() => {
    if (clientMenu.length > 2) {
      dispatch(setRestrictions(JSON.parse(clientMenu)?.client_menu?.elements));
    }
  }, [clientMenu]);

  switch (true) {
    case isLoading: {
      return <SkeletonHeaderMenu />;
    }
    case isError: {
      return <ErrorComponent />;
    }
    default: {
      const menuData = data?.menu;
      return menuData ? (
        <MainMenuContainerWithCategoryIds menu={menuData} />
      ) : null;
    }
  }
};

export default MainMenuContainer;